(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_build-bundle-basket"] && !Shopify.designMode) return;
  try {
    class BuildBundleBasket extends HTMLElement {
    escapeHtml(value) {
      const div = document.createElement('div');
      div.textContent = value === null || value === undefined ? '' : String(value);
      return div.innerHTML;
    }

    formatMoney(cents) {
      if (window.WDN && window.WDN.Money && typeof window.WDN.Money.Format === 'function') {
        return window.WDN.Money.Format(cents, true);
      }

      return String(cents);
    }

    getOptionEntries(variant) {
      const names = Array.isArray(variant.optionNames) ? variant.optionNames : [];
      const values = Array.isArray(variant.options) ? variant.options : [];

      return values
        .map(function mapOption(value, index) {
          return { name: names[index], value: value };
        })
        .filter(function filterOption(option) {
          return Boolean(option.name) && Boolean(option.value) && option.value !== 'Default Title';
        });
    }

    getImageUrl(variant) {
      const src = (variant.featured_image && variant.featured_image.src) || variant.productImage || '';

      if (!src) {
        return '';
      }

      return src + (src.includes('?') ? '&' : '?') + 'width=100';
    }

    getItemPrice(variant) {
      return Math.max(variant.price, variant.compare_at_price || 0);
    }

    computeTotal(items) {
      return Object.keys(items).reduce(
        function reduceTotal(sum, slotIndex) {
          return sum + this.getItemPrice(items[slotIndex]);
        }.bind(this),
        0
      );
    }

    renderFatalError(message) {
      return `<div class="build-bundle-basket__fatal-error"><p>${this.escapeHtml(message)}</p></div>`;
    }

    renderThumb(index, variant) {
      if (!variant) {
        return `
          <span class="build-bundle-basket__bar-thumb">
            <span class="build-bundle-basket__bar-thumb-placeholder" aria-hidden="true"></span>
          </span>
        `;
      }

      const title = variant.productTitle || variant.name || variant.title;
      const imageUrl = this.getImageUrl(variant);
      const animateClass = index === this.animateIndex ? ' is-new' : '';

      return `
        <span class="build-bundle-basket__bar-thumb is-filled${animateClass}">
          <img
            class="build-bundle-basket__bar-thumb-image"
            src="${this.escapeHtml(imageUrl)}"
            alt="${this.escapeHtml(title)}"
          >
          <button
            type="button"
            class="build-bundle-basket__bar-thumb-remove"
            data-action="remove"
            data-slot-index="${index}"
            aria-label="${this.escapeHtml(this.dataset.i18nRemove)}"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" aria-hidden="true">
              <use href="#icon-close-red"></use>
            </svg>
          </button>
        </span>
      `;
    }

    renderSlot(index, variant) {
      if (!variant) {
        return `
          <div class="build-bundle-basket__slot">
            <span class="build-bundle-basket__slot-text">${this.escapeHtml(this.dataset.i18nSelectItem)}</span>
          </div>
        `;
      }

      const title = variant.productTitle || variant.name || variant.title;
      const options = this.getOptionEntries(variant);
      const price = this.getItemPrice(variant);
      const imageUrl = this.getImageUrl(variant);

      const optionsHtml = options
        .map(function mapOptionRow(option) {
          const name = this.escapeHtml(option.name);
          const value = this.escapeHtml(option.value);
          return `<p class="build-bundle-basket__slot-option">${name}: ${value}</p>`;
        }, this)
        .join('');

      const animateClass = index === this.animateIndex ? ' is-new' : '';

      return `
        <div class="build-bundle-basket__slot is-filled${animateClass}">
          <div class="build-bundle-basket__slot-image-wrapper">
            <img
              class="build-bundle-basket__slot-image"
              src="${this.escapeHtml(imageUrl)}"
              alt="${this.escapeHtml(title)}"
            >
          </div>
          <div class="build-bundle-basket__slot-content">
            <p class="build-bundle-basket__slot-title">${this.escapeHtml(title)}</p>
            ${optionsHtml ? `<div class="build-bundle-basket__slot-options">${optionsHtml}</div>` : ''}
            <span class="build-bundle-basket__slot-price">${this.escapeHtml(this.formatMoney(price))}</span>
          </div>
          <button
            type="button"
            class="build-bundle-basket__slot-remove"
            data-action="remove"
            data-slot-index="${index}"
            aria-label="${this.escapeHtml(this.dataset.i18nRemove)}"
          >
            <span class="icon icon:xs"><svg viewbox="0 0 14 14"><use href="#icon-trash"></use></svg></span>
          </button>
        </div>
      `;
    }

    renderPricing(state) {
      const total = this.computeTotal(state.items);
      const finalPrice = Math.round(state.entry.price * 100);
      const hasSavings = total > 0 && finalPrice > 0 && total > finalPrice;
      const savePercent = hasSavings ? Math.round(((total - finalPrice) / total) * 100) : 0;
      const isEmpty = total <= 0;

      const finalPriceHtml = hasSavings
        ? `<p class="build-bundle-basket__pricing-final">${this.escapeHtml(this.formatMoney(finalPrice))}</p>`
        : '';

      return `
        <div class="build-bundle-basket__pricing"${isEmpty ? ' data-empty' : ''}>
          <p class="build-bundle-basket__pricing-total">${this.escapeHtml(this.formatMoney(total))}</p>
          ${finalPriceHtml}
          <span class="build-bundle-basket__pricing-save"${hasSavings ? '' : ' hidden'}>-${savePercent}%</span>
        </div>
      `;
    }

    renderBarPricing(state) {
      const total = this.computeTotal(state.items);
      const finalPrice = Math.round(state.entry.price * 100);
      const hasSavings = total > 0 && finalPrice > 0 && total > finalPrice;
      const isEmpty = total <= 0;

      const finalPriceHtml = hasSavings
        ? `<span class="build-bundle-basket__bar-pricing-final">${this.escapeHtml(this.formatMoney(finalPrice))}</span>`
        : '';

      return `
        <div class="build-bundle-basket__bar-pricing"${isEmpty ? ' data-empty' : ''}>
          <span class="build-bundle-basket__bar-pricing-total">${this.escapeHtml(this.formatMoney(total))}</span>
          ${finalPriceHtml}
        </div>
      `;
    }

    renderCartError(state) {
      if (!state.cartError) {
        return '<p class="build-bundle-basket__error" hidden></p>';
      }

      return `<p class="build-bundle-basket__error">${this.escapeHtml(state.cartError)}</p>`;
    }

    renderContent(state) {
      const entry = state.entry;
      const size = entry.size;
      const filledCount = Object.keys(state.items).length;
      const isComplete = filledCount >= size;
      const remainingCount = Math.max(size - filledCount, 0);
      const submitLabel = isComplete
        ? this.dataset.i18nAddToCart
        : (remainingCount === 1 ? this.dataset.i18nSelectProduct : this.dataset.i18nSelectProducts).replace(
            '__COUNT__',
            remainingCount
          );
      const panelId = 'build-bundle-basket-panel-' + entry.id;

      let slotsHtml = '';
      let thumbsHtml = '';

      for (let index = 0; index < size; index++) {
        slotsHtml += this.renderSlot(index, state.items[index]);
        thumbsHtml += this.renderThumb(index, state.items[index]);
      }

      return `
        <div class="build-bundle-basket__bar" data-bar>
          <div
            class="build-bundle-basket__bar-toggle"
            data-action="toggle"
            role="button"
            tabindex="0"
            aria-expanded="false"
            aria-controls="${panelId}"
          >
            <span class="build-bundle-basket__bar-thumbs">${thumbsHtml}</span>
            <span class="build-bundle-basket__bar-caret" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 6" fill="none">
                <use href="#icon-chevrondown" />
              </svg>
            </span>
          </div>

          <div class="build-bundle-basket__bar-cta">
            ${this.renderBarPricing(state)}
            <button
              type="button"
              class="build-bundle-basket__bar-submit"
              data-action="add-to-cart"
              ${isComplete ? '' : 'aria-disabled="true"'}
            >
              ${submitLabel}
            </button>
          </div>
        </div>

        <div class="build-bundle-basket__overlay" data-action="close"></div>

        <div class="build-bundle-basket__inner" id="${panelId}" role="dialog" aria-modal="true" tabindex="-1">
          <div class="build-bundle-basket__header">
            <span class="build-bundle-basket__header-title">${this.escapeHtml(entry.title)}</span>
            <button class="build-bundle-basket__close" type="button" data-action="close" aria-label="${this.escapeHtml(
              this.dataset.i18nClose
            )}">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" aria-hidden="true">
                <use href="#icon-close" />
              </svg>
            </button>
          </div>

          <div class="build-bundle-basket__slots">${slotsHtml}</div>

          ${this.renderPricing(state)}
          ${this.renderCartError(state)}

          <button
            type="button"
            class="build-bundle-basket__submit"
            data-action="add-to-cart"
            ${isComplete ? '' : 'aria-disabled="true"'}
          >
            ${submitLabel}
          </button>
        </div>
      `;
    }

    renderBasket(state) {
      if (state.status === 'error') {
        return this.renderFatalError(state.errorMessage);
      }

      return this.renderContent(state);
    }

    connectedCallback() {
      this.state = this.buildInitialState();
      this.animateIndex = null;
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onGlobalKeydown = this.onGlobalKeydown.bind(this);

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onHostKeydown.bind(this));

      this.render();

      if (!this.isMoneyFormatterReady()) {
        document.addEventListener('DOMContentLoaded', this.render.bind(this), { once: true });
      }
    }

    isMoneyFormatterReady() {
      return Boolean(window.WDN && window.WDN.Money && typeof window.WDN.Money.Format === 'function');
    }

    buildInitialState() {
      const entry = {
        id: this.dataset.bundleId,
        title: this.dataset.bundleTitle,
        size: Number(this.dataset.bundleSize),
        price: Number(this.dataset.bundlePrice),
      };

      return {
        status: 'ready',
        collectionId: this.dataset.collectionId,
        errorMessage: null,
        entry: entry,
        items: this.readPersistedItems(entry.id, this.dataset.collectionId),
        cartError: null,
      };
    }

    buildErrorState(message, collectionId) {
      console.error('Build bundle basket:', message, 'collection id:', collectionId);

      return {
        status: 'error',
        errorMessage: message,
        entry: null,
        items: {},
        cartError: null,
      };
    }

    setState(patch) {
      this.state = Object.assign({}, this.state, patch);
      this.render();
    }

    render() {
      this.innerHTML = this.renderBasket(this.state);
      this.syncToggleAria();
      this.syncWaveLevel();
    }

    syncWaveLevel() {
      if (!this.hasAttribute('data-wave') || !this.state.entry || !this.state.entry.size) {
        return;
      }

      const ratio = Math.min(Object.keys(this.state.items).length / this.state.entry.size, 1);
      this.style.setProperty('--bundle-wave-fill', ratio);
    }

    syncToggleAria() {
      const toggleEl = this.querySelector('[data-action="toggle"]');

      if (!toggleEl) {
        return;
      }

      toggleEl.setAttribute('aria-expanded', this.hasAttribute('open') ? 'true' : 'false');
    }

    onClick(e) {
      const actionEl = e.target.closest('[data-action]');

      if (!actionEl) {
        return;
      }

      const action = actionEl.dataset.action;

      if (action === 'remove') {
        e.stopPropagation();
        this.removeItem(Number(actionEl.dataset.slotIndex));
        return;
      }

      if (action === 'toggle') {
        this.toggle();
        return;
      }

      if (action === 'close') {
        this.close();
        return;
      }

      if (action === 'add-to-cart') {
        this.onAddToCart();
      }
    }

    onHostKeydown(e) {
      const toggleEl = e.target.closest('[data-action="toggle"]');

      if (!toggleEl) {
        return;
      }

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggle();
      }
    }

    addItem(variant) {
      if (this.state.status !== 'ready') {
        return false;
      }

      const size = this.state.entry.size;
      let targetIndex = -1;

      for (let index = 0; index < size; index++) {
        if (!(index in this.state.items)) {
          targetIndex = index;
          break;
        }
      }

      if (targetIndex === -1) {
        console.warn('Build bundle basket is full; item was not added.', variant);
        this.pulseFull();
        return false;
      }

      const items = Object.assign({}, this.state.items);
      items[targetIndex] = variant;

      /*
       * animateIndex is a transient render hint, not data: it marks which single
       * slot/thumb just changed so renderSlot/renderThumb can attach the pop
       * animation there only, instead of every already-filled slot replaying it
       * on every full re-render. Cleared right after the render it drove.
       */
      this.animateIndex = targetIndex;
      this.setState({ items: items, cartError: null });
      this.animateIndex = null;

      this.persistItems();
      return true;
    }

    /*
     * No data changes in these cases, so there's nothing for a state-driven
     * re-render to reflect. Instead, directly replay the pop animation on the
     * matching slots/thumbs (remove class, force reflow, add class back), same
     * trick used for the pop-in animation.
     */
    pulseElements(selector) {
      this.querySelectorAll(selector).forEach(function pulse(el) {
        el.classList.remove('is-new');
        void el.offsetWidth;
        el.classList.add('is-new');
        el.addEventListener(
          'animationend',
          function clearPulse() {
            el.classList.remove('is-new');
          },
          { once: true }
        );
      });
    }

    /* Basket already full: flash what's in it. */
    pulseFull() {
      this.pulseElements('.build-bundle-basket__slot.is-filled, .build-bundle-basket__bar-thumb.is-filled');
    }

    /* Submit clicked too early: flash the slots still waiting to be filled. */
    pulseEmpty() {
      this.pulseElements('.build-bundle-basket__slot:not(.is-filled), .build-bundle-basket__bar-thumb:not(.is-filled)');
    }

    removeItem(slotIndex) {
      if (!(slotIndex in this.state.items)) {
        return;
      }

      const items = Object.assign({}, this.state.items);
      delete items[slotIndex];

      this.animateIndex = null;
      this.setState({ items: items });

      this.persistItems();
    }

    toggle() {
      if (this.hasAttribute('open')) {
        this.close();
      } else {
        this.openPanel();
      }
    }

    /*
     * Open/closed is transient view state driven by the [open] attribute, kept
     * outside this.state on purpose: the slide-up/down transition needs the panel
     * node to stay in the DOM across the animation, which a full re-render would break.
     */
    openPanel() {
      this.setAttribute('open', '');
      this.syncToggleAria();
      this.lockScrollForMobile();
      document.addEventListener('keydown', this.onGlobalKeydown);
      document.addEventListener('click', this.onDocumentClick);

      const panel = this.querySelector('.build-bundle-basket__inner');

      if (panel) {
        panel.focus();
      }
    }

    close() {
      if (!this.hasAttribute('open')) {
        return;
      }

      this.removeAttribute('open');
      this.syncToggleAria();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onGlobalKeydown);
      document.removeEventListener('click', this.onDocumentClick);
    }

    lockScrollForMobile() {
      if (window.matchMedia('(max-width: 749px)').matches) {
        document.body.style.overflow = 'hidden';
      }
    }

    onGlobalKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
      }
    }

    onDocumentClick(e) {
      if (this.contains(e.target)) {
        return;
      }

      this.close();
    }

    readPersistedItems(entryId, collectionId) {
      const key = `build-bundle-basket:${collectionId}:${entryId}`;
      try {
        const raw = window.localStorage.getItem(key);
        return raw ? JSON.parse(raw) : {};
      } catch (error) {
        console.error(error);
        return {};
      }
    }

    persistItems() {
      try {
        const key = `build-bundle-basket:${this.state.collectionId}:${this.state.entry.id}`;
        window.localStorage.setItem(key, JSON.stringify(this.state.items));
      } catch (error) {
        console.error(error);
      }
    }

    async onAddToCart() {
      if (this.state.status !== 'ready') {
        return;
      }

      /* Not enough products picked yet: flash the empty slots instead of adding. */
      if (Object.keys(this.state.items).length < this.state.entry.size) {
        this.pulseEmpty();
        return;
      }

      // Reduce by qty baswed on variant id
      const items = Object.values(this.state.items).reduce((acc, variant) => {
        const existingItem = acc.find((item) => item.id === variant.id);
        if (existingItem) {
          existingItem.quantity += 1;
        } else {
          acc.push({
            id: variant.id,
            quantity: 1,
            properties: { '_build-bundle': `${this.state.collectionId}:${this.state.entry.id}:${Date.now()}` },
          });
        }
        return acc;
      }, []);

      if (!items.length) {
        return;
      }

      this.setState({ cartError: null });

      let res;
      let data;

      try {
        res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items: items }),
        });

        data = await res.json();
      } catch (error) {
        console.error(error);
        this.setState({ cartError: this.dataset.i18nError });
        return;
      }

      if (!res.ok || (data && data.status >= 400)) {
        const message = (data && (data.description || data.message)) || this.dataset.i18nError;
        console.error(message);
        this.setState({ cartError: message });
        return;
      }

      this.animateIndex = null;
      this.setState({ items: {}, cartError: null });
      this.persistItems();
      this.close();

      document.body.dispatchEvent(new CustomEvent('cartcount:update'));

      const cart = document.querySelector('wdn-cart');

      if (cart) {
        cart.reloadCart();
      }
    }
  }

  if (!customElements.get('build-bundle-basket-component')) {
    customElements.define('build-bundle-basket-component', BuildBundleBasket);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_collection-filters"] && !Shopify.designMode) return;
  try {
    const FILTERS_RENDER_DELAY = 250;
  const FILTERS_PRESERVED_PARAMS = ['q', 'sort_by', 'view', 'options[prefix]', 'options[unavailable_products]'];
  const FILTERS_COLLECTION_PARAM = 'filter.p.m.product.collection_ids';
  const FILTERS_PRICE_PARAMS = ['filter.v.price.gte', 'filter.v.price.lte'];
  const FILTERS_SCROLL_OFFSET = 20;
  const FILTERS_MOBILE_BREAKPOINT = 1240;

  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('[section-id]');
      this.sectionId = this.dataset.sectionId || (this.section && this.section.getAttribute('section-id'));
      this.results = this.section && this.section.querySelector('#ResultsList');
      this.activeRegion = this.querySelector('[data-filters-active]');
      this.searchInput = this.querySelector('[data-filters-search-input]');
      this.modal = this.querySelector('[data-filters-modal]');
      this.renderTimer = null;
      this.searchTimer = null;
      this.abortController = null;
      this.scrollAfterRender = false;
      this.cache = new Map();

      this.onHostClick = this.handleClick.bind(this);
      this.onHostChange = this.handleChange.bind(this);
      this.onHostInput = this.handleInput.bind(this);
      this.onHostSubmit = this.handleSubmit.bind(this);
      this.onDocumentClick = this.handleDocumentClick.bind(this);
      this.onPopState = this.handlePopState.bind(this);
      this.onOverlayClosed = this.handleOverlayClosed.bind(this);

      this.addEventListener('click', this.onHostClick);
      this.addEventListener('change', this.onHostChange);
      this.addEventListener('input', this.onHostInput);
      this.addEventListener('submit', this.onHostSubmit);
      document.addEventListener('click', this.onDocumentClick);
      window.addEventListener('popstate', this.onPopState);
      // wdn-modal announces itself on document.body (see WDNOverlay in main.js).
      document.body.addEventListener('overlay:closed', this.onOverlayClosed);

      const params = this.readParams();
      // Alternate template (?view=…) the page was loaded with — must survive every
      // URL rewrite and section fetch, or the results come back from the default template.
      this.viewParam = params.get('view') || '';
      if (this.searchInput) {
        this.searchInput.value = params.get('q') || '';
      }
      if (params.get('q')) {
        this.updateResults(params);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      window.removeEventListener('popstate', this.onPopState);
      document.body.removeEventListener('overlay:closed', this.onOverlayClosed);
      clearTimeout(this.renderTimer);
      clearTimeout(this.searchTimer);
      if (this.abortController) {
        this.abortController.abort();
      }
    }

    /* ---------------- Event delegation ---------------- */
    handleClick(event) {
      const trigger = event.target.closest('[data-filters-toggle]');
      if (trigger) {
        this.toggleDropdown(trigger.closest('.collection-filters__group'));
        return;
      }
      if (event.target.closest('[data-filters-sort-toggle]')) {
        if (this.isMobile()) {
          this.openMobileSort();
        } else {
          this.toggleDropdown(this.querySelector('[data-filters-sort]'));
        }
        return;
      }
      const slideTrigger = event.target.closest('[data-filters-slide-open]');
      if (slideTrigger) {
        this.openSlide(slideTrigger.getAttribute('data-filters-slide-open'));
        return;
      }
      if (event.target.closest('[data-filters-slide-close]')) {
        this.closeSlides();
        return;
      }
      if (event.target.closest('[data-filters-scrim]')) {
        this.closeDropdowns();
        return;
      }
      const sortOption = event.target.closest('[data-filters-sort-option]');
      if (sortOption) {
        this.selectSort(sortOption);
        return;
      }
      if (event.target.closest('[data-filters-close]')) {
        this.closeDropdowns();
        return;
      }
      const chip = event.target.closest('[data-filters-remove]');
      if (chip) {
        this.removeChip(chip);
        return;
      }
      if (event.target.closest('[data-filters-clear]')) {
        this.clearAll();
      }
    }

    handleChange(event) {
      const checkbox = event.target.closest('[data-filters-check]');
      if (checkbox) {
        this.toggleOption(checkbox);
        return;
      }
      const priceField = event.target.closest('[data-filters-min], [data-filters-max], [data-filters-slider]');
      if (priceField) {
        this.applyPrice(priceField.closest('[data-filters-range]'));
      }
    }

    // Keep the number input and its slider visually in sync while dragging/typing.
    handleInput(event) {
      if (event.target.closest('[data-filters-search-input]')) {
        this.queueSearch();
        return;
      }

      const slider = event.target.closest('[data-filters-slider]');
      if (slider) {
        const bound = slider.getAttribute('data-filters-slider');
        const field = slider.closest('[data-filters-range]').querySelector('[data-filters-' + bound + ']');
        if (field) {
          field.value = slider.value;
        }
        return;
      }
      const field = event.target.closest('[data-filters-min], [data-filters-max]');
      if (field) {
        const bound = field.hasAttribute('data-filters-min') ? 'min' : 'max';
        const paired = field.closest('[data-filters-range]').querySelector('[data-filters-slider="' + bound + '"]');
        if (paired) {
          paired.value = field.value;
        }
      }
    }

    handleSubmit(event) {
      if (!event.target.closest('[data-filters-search-form]')) {
        return;
      }
      event.preventDefault();
      clearTimeout(this.searchTimer);
      this.applySearch();
    }

    handleDocumentClick(event) {
      const paginationLink = event.target.closest('#ResultsList .pagination a[href]');
      if (paginationLink && this.results && this.results.contains(paginationLink)) {
        event.preventDefault();
        const pageUrl = new URL(paginationLink.href, window.location.origin);
        const params = pageUrl.searchParams;
        params.delete('view');
        params.delete('section_id');
        params.delete('type');
        params.delete(FILTERS_COLLECTION_PARAM);
        if (this.viewParam) {
          params.set('view', this.viewParam);
        }
        // Paging swaps the grid under the user, so bring them back to its top.
        this.scrollAfterRender = true;
        this.commit(params, { resetPage: false, delay: 0 });
        return;
      }

      if (!this.contains(event.target)) {
        this.closeDropdowns();
      }
    }

    handlePopState() {
      const params = this.readParams();
      if (this.searchInput) {
        this.searchInput.value = params.get('q') || '';
      }
      this.updateResults(params);
    }

    /* ---------------- Dropdowns ---------------- */
    toggleDropdown(group) {
      if (!group) {
        return;
      }
      const wasOpen = group.hasAttribute('data-open');
      this.closeDropdowns();
      if (!wasOpen) {
        group.setAttribute('data-open', '');
        document.body.classList.add('collection-filters-open');
      }
    }

    closeDropdowns() {
      for (const open of this.querySelectorAll('[data-open]')) {
        open.removeAttribute('data-open');
      }
      document.body.classList.remove('collection-filters-open');
    }

    /* ---------------- Mobile drawer slides ---------------- */
    isMobile() {
      return window.innerWidth <= FILTERS_MOBILE_BREAKPOINT;
    }

    openSlide(id) {
      for (const slide of this.querySelectorAll('[data-filters-slide]')) {
        const isTarget = slide.getAttribute('data-filters-slide') === id;
        slide.toggleAttribute('data-visible', isTarget);
        if (!isTarget) {
          continue;
        }
        const body = slide.querySelector('.collection-filters__slide-body');
        if (body) {
          body.scrollTop = 0;
        }
      }
    }

    closeSlides() {
      for (const slide of this.querySelectorAll('[data-filters-slide][data-visible]')) {
        slide.removeAttribute('data-visible');
      }
    }

    openMobileSort() {
      if (!this.modal || typeof this.modal.open !== 'function') {
        return;
      }
      this.closeDropdowns();
      this.openSlide(this.dataset.sortSlideId);
      this.modal.open();
    }

    // Slides keep their state while the drawer is closed, so reset them on close.
    handleOverlayClosed(event) {
      if (event.detail === this.modal) {
        this.closeSlides();
      }
    }

    /* ---------------- URL / params ---------------- */
    readParams() {
      return new URLSearchParams(window.location.search);
    }

    // Add or remove a single value of a param that may repeat (list filters).
    setRepeatedValue(params, name, value, shouldAdd) {
      const values = params.getAll(name).filter((entry) => entry !== value);
      if (shouldAdd) {
        values.push(value);
      }
      params.delete(name);
      for (const entry of values) {
        params.append(name, entry);
      }
    }

    // Commit params to the collection URL, then schedule a results refresh.
    commit(params, { resetPage = true, delay = FILTERS_RENDER_DELAY } = {}) {
      params = new URLSearchParams(params);
      if (resetPage) {
        params.delete('page');
      }
      const query = params.toString();
      const pathname = this.dataset.collectionUrl || window.location.pathname;
      const url = query ? pathname + '?' + query : pathname;
      window.history.pushState({}, '', url);

      clearTimeout(this.renderTimer);
      this.renderTimer = setTimeout(this.updateResults.bind(this, params), delay);
    }

    queueSearch() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(this.applySearch.bind(this), FILTERS_RENDER_DELAY);
    }

    applySearch() {
      const params = this.readParams();
      const query = this.searchInput ? this.searchInput.value.trim() : '';
      if (query) {
        params.set('q', query);
      } else {
        params.delete('q');
      }
      this.commit(params, { delay: 0 });
    }

    /* ---------------- Filter actions ---------------- */
    toggleOption(checkbox) {
      const params = this.readParams();
      this.setRepeatedValue(
        params,
        checkbox.getAttribute('data-filters-param'),
        checkbox.getAttribute('data-filters-value'),
        checkbox.checked
      );
      this.commit(params);
    }

    selectSort(option) {
      const params = this.readParams();
      params.set('sort_by', option.getAttribute('data-filters-value'));

      for (const sibling of option.parentNode.querySelectorAll('[data-filters-sort-option]')) {
        sibling.removeAttribute('data-filters-selected');
      }
      option.setAttribute('data-filters-selected', '');

      const current = this.querySelector('[data-filters-sort-current]');
      if (current) {
        current.textContent = option.textContent.trim();
      }
      this.closeDropdowns();
      this.commit(params);
    }

    applyPrice(range) {
      if (!range) {
        return;
      }
      const rangeMax = parseFloat(range.getAttribute('data-filters-range-max'));
      const minField = range.querySelector('[data-filters-min]');
      const maxField = range.querySelector('[data-filters-max]');
      const params = this.readParams();

      if (parseFloat(minField.value) > 0) {
        params.set(minField.getAttribute('data-filters-param'), minField.value);
      } else {
        params.delete(minField.getAttribute('data-filters-param'));
      }
      if (parseFloat(maxField.value) < rangeMax) {
        params.set(maxField.getAttribute('data-filters-param'), maxField.value);
      } else {
        params.delete(maxField.getAttribute('data-filters-param'));
      }
      this.commit(params);
    }

    removeChip(chip) {
      const params = this.readParams();
      if (chip.hasAttribute('data-filters-price')) {
        for (const name of FILTERS_PRICE_PARAMS) {
          params.delete(name);
        }
      } else {
        this.setRepeatedValue(
          params,
          chip.getAttribute('data-filters-param'),
          chip.getAttribute('data-filters-value'),
          false
        );
      }
      this.commit(params);
    }

    clearAll() {
      const current = this.readParams();
      const next = new URLSearchParams();
      for (const key of FILTERS_PRESERVED_PARAMS) {
        if (current.has(key)) {
          next.set(key, current.get(key));
        }
      }
      this.commit(next);
    }

    /* ---------------- Section Rendering API refresh ---------------- */
    async updateResults(params) {
      if (!this.sectionId || !this.results) {
        return;
      }

      const requestParams = new URLSearchParams(params);
      const searchQuery = (requestParams.get('q') || '').trim();
      let pathname = this.dataset.collectionUrl || window.location.pathname;

      requestParams.delete('view');
      requestParams.delete('section_id');
      requestParams.delete('type');
      requestParams.delete(FILTERS_COLLECTION_PARAM);

      if (searchQuery) {
        pathname = this.dataset.searchUrl || '/search';
        requestParams.set('q', searchQuery);
        requestParams.set('type', 'product');
        requestParams.set('view', this.dataset.searchView);
        if (this.dataset.collectionId) {
          requestParams.set(FILTERS_COLLECTION_PARAM, this.dataset.collectionId);
        }
      } else {
        requestParams.delete('q');
        requestParams.set('section_id', this.sectionId);
        // Keep the alternate template so the section renders from it, not the default one.
        if (this.viewParam) {
          requestParams.set('view', this.viewParam);
        }
      }

      const query = requestParams.toString();
      const url = query ? pathname + '?' + query : pathname;

      if (this.abortController) {
        this.abortController.abort();
      }
      const controller = new AbortController();
      this.abortController = controller;

      // Serve a cached response instantly (no spinner, no refetch).
      const cached = this.cache.get(url);
      if (cached) {
        this.render(new DOMParser().parseFromString(cached, 'text/html'));
        this.abortController = null;
        this.setLoading(false);
        return;
      }

      this.setLoading(true);

      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) {
          throw new Error('Filter fetch failed: ' + response.status);
        }
        const text = await response.text();
        this.cache.set(url, text);
        this.render(new DOMParser().parseFromString(text, 'text/html'));
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error(error);
        }
      } finally {
        if (this.abortController === controller) {
          this.abortController = null;
          this.setLoading(false);
        }
      }
    }

    render(doc) {
      // ResultsList owns both the product grid and pagination, so one replacement
      // keeps their page state in sync.
      const results = doc.querySelector('#ResultsList');
      if (results) {
        const nextResults = results.cloneNode(true);
        this.results.replaceWith(nextResults);
        this.results = nextResults;
      }
      const active = doc.querySelector('[data-filters-active]');
      if (this.activeRegion && active) {
        this.activeRegion.innerHTML = active.innerHTML;
        this.activeRegion.classList.toggle('collection-filters__active--visible', active.children.length > 0);
      }

      // Patch the still-mounted controls in place.
      this.syncOptions(doc);
      this.syncGroupSummaries(doc);
      this.syncPrice(doc);
      this.syncSort(doc);
      this.syncResultCount(doc);

      if (this.scrollAfterRender) {
        this.scrollAfterRender = false;
        this.scrollToResults();
      }
    }

    // Scroll the top of the grid just below the sticky header.
    scrollToResults() {
      if (!this.results) {
        return;
      }
      const headerHeight = parseInt(document.documentElement.style.getPropertyValue('--header-height'), 10) || 0;
      const top = this.results.getBoundingClientRect().top + window.scrollY - headerHeight - FILTERS_SCROLL_OFFSET;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }

    syncOptions(doc) {
      const fresh = new Map();
      for (const option of doc.querySelectorAll('[data-filters-list] [data-filters-option]')) {
        const input = option.querySelector('[data-filters-check]');
        const count = option.querySelector('[data-filters-count]');
        fresh.set(option.getAttribute('data-filters-id'), {
          checked: input ? input.checked : false,
          count: count ? count.textContent : '',
          disabled: option.closest('.collection-filters__option-row').hasAttribute('data-filters-disabled'),
        });
      }

      // Desktop + mobile options share ids, so a single pass updates both.
      for (const option of this.querySelectorAll('[data-filters-option]')) {
        const next = fresh.get(option.getAttribute('data-filters-id'));
        if (!next) {
          continue;
        }
        const input = option.querySelector('[data-filters-check]');
        if (input) {
          input.checked = next.checked;
        }
        const count = option.querySelector('[data-filters-count]');
        if (count) {
          count.textContent = next.count;
        }
        option.closest('.collection-filters__option-row').toggleAttribute('data-filters-disabled', next.disabled);
      }
    }

    syncGroupSummaries(doc) {
      // Only the mobile rows carry a summary — the desktop group for the same key
      // comes first in the document and would otherwise blank it out.
      const summaries = new Map();
      for (const badge of doc.querySelectorAll('[data-filters-group] [data-filters-group-summary]')) {
        const key = badge.closest('[data-filters-group]').getAttribute('data-filters-group');
        if (summaries.has(key)) {
          continue;
        }
        summaries.set(key, badge.textContent.trim());
      }
      for (const group of this.querySelectorAll('[data-filters-group]')) {
        const badge = group.querySelector('[data-filters-group-summary]');
        if (badge) {
          badge.textContent = summaries.get(group.getAttribute('data-filters-group')) || '';
        }
      }
    }

    // Mirror the server's clamped price values onto every range group + slider.
    syncPrice(doc) {
      const source = doc.querySelector('[data-filters-range]');
      if (!source) {
        return;
      }
      const min = source.querySelector('[data-filters-min]').value;
      const max = source.querySelector('[data-filters-max]').value;
      for (const range of this.querySelectorAll('[data-filters-range]')) {
        this.setRangeValue(range, 'min', min);
        this.setRangeValue(range, 'max', max);
      }
    }

    syncSort(doc) {
      const source = doc.querySelector('[data-filters-sort-option][data-filters-selected]');
      if (!source) {
        return;
      }
      const value = source.getAttribute('data-filters-value');
      for (const option of this.querySelectorAll('[data-filters-sort-option]')) {
        option.toggleAttribute('data-filters-selected', option.getAttribute('data-filters-value') === value);
      }
      const current = this.querySelector('[data-filters-sort-current]');
      if (current) {
        current.textContent = source.textContent.trim();
      }
    }

    setRangeValue(range, bound, value) {
      const field = range.querySelector('[data-filters-' + bound + ']');
      const slider = range.querySelector('[data-filters-slider="' + bound + '"]');
      if (field) {
        field.value = value;
      }
      if (slider) {
        slider.value = value;
      }
    }

    syncResultCount(doc) {
      const source = doc.querySelector('[data-filters-result-count]');
      if (!source) {
        return;
      }
      for (const target of this.querySelectorAll('[data-filters-result-count]')) {
        target.textContent = source.textContent;
      }
      for (const target of this.querySelectorAll('[data-filters-results-count]')) {
        const template = target.dataset.filtersResultsCountTemplate;
        target.textContent = template
          ? template.replace('__FILTER_RESULTS_COUNT__', source.textContent)
          : source.textContent;
      }
      for (const target of this.querySelectorAll('[data-filters-results-text]')) {
        const template = target.dataset.filtersResultsTextTemplate;
        target.textContent = template
          ? template.replace('__FILTER_RESULTS_COUNT__', source.textContent)
          : source.textContent;
      }
    }

    setLoading(isLoading) {
      if (this.results) {
        this.results.toggleAttribute('data-filters-loading', isLoading);
        this.results.setAttribute('aria-busy', String(isLoading));
      }
    }
  }

  if (!customElements.get('collection-filters')) {
    customElements.define('collection-filters', CollectionFilters);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-page-sticky-nav"] && !Shopify.designMode) return;
  try {
    class ProductStickyNav extends HTMLElement {
    static sectionSelector = '.group-block, .section, .accordion-block-item';
    static scrollThrottleDelay = 90;
    static activeTolerance = 24;
    /* A section keeps the tab until its top is this far below the bar again */
    static activeLeeway = 150;

    constructor() {
      super();

      this.targets = [];
      this.inner = null;
      this.list = null;
      this.lastScrollHandled = 0;
      this.activeTarget = null;
      this.pendingTarget = null;
      this.pendingTimeout = null;
      this.onWindowScroll = this.onWindowScroll.bind(this);
      this.clearPendingTarget = this.clearPendingTarget.bind(this);
    }

    connectedCallback() {
      /* Sticky is clipped by the product page container, so the bar is moved into the header itself */
      const header = document.querySelector('[data-header] header');

      if (header && this.parentElement !== header) {
        header.appendChild(this);
        return;
      }

      this.inner = this.querySelector('.product-sticky-nav__inner');
      this.list = this.querySelector('.product-sticky-nav__list');
      this.targets = this.findTargets();

      if (!this.targets.length) {
        return;
      }

      this.renderTabs();
      this.removeAttribute('data-not-mounted');
      this.updateActiveTab();

      window.addEventListener('scroll', this.onWindowScroll, { passive: true });
      window.addEventListener('scrollend', this.clearPendingTarget);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onWindowScroll);
      window.removeEventListener('scrollend', this.clearPendingTarget);
    }

    /* Walks the page in document order and picks up every section carrying data-toc="<title>" */
    findTargets() {
      const targets = [];

      for (const element of document.querySelectorAll(ProductStickyNav.sectionSelector)) {
        if (this.contains(element)) {
          continue;
        }

        const label = (element.dataset.toc || '').trim();

        if (!label) {
          continue;
        }

        targets.push({
          name: String(targets.length),
          label: label,
          element: element,
        });
      }

      return targets;
    }

    renderTabs() {
      const fragment = document.createDocumentFragment();

      for (const target of this.targets) {
        const item = document.createElement('li');
        item.className = 'product-sticky-nav__item';
        item.setAttribute('data-tab-id', target.name);

        const button = document.createElement('button');
        button.className = 'product-sticky-nav__button';
        button.type = 'button';
        button.textContent = target.label;
        button.addEventListener('click', () => {
          this.scrollToTarget(target);
        });

        item.appendChild(button);
        fragment.appendChild(item);
      }

      this.list.appendChild(fragment);
    }

    /* The section is aligned to the bottom edge of the bar, which already sits below the sticky header */
    get edgeOffset() {
      return this.getBoundingClientRect().bottom;
    }

    scrollToTarget(target) {
      ProductStickyNav.openAccordion(target.element);

      const rect = target.element.getBoundingClientRect();
      const top = window.scrollY + rect.top - this.edgeOffset;

      window.scrollTo({
        top: top,
        behavior: 'smooth',
      });

      /* The clicked tab is marked right away and kept until the smooth scroll settles,
         otherwise the sections passing by on the way steal the active state */
      this.activateTarget(target);
      this.pendingTarget = target;

      clearTimeout(this.pendingTimeout);
      this.pendingTimeout = setTimeout(this.clearPendingTarget, 800);
    }

    /* Accordion sections are wdn-dropdown elements, they are expanded before scrolling to them */
    static openAccordion(element) {
      if (!element.classList.contains('accordion-block-item')) {
        return;
      }

      if (element.isActive || typeof element.setActive !== 'function') {
        return;
      }

      element.setActive();
    }

    clearPendingTarget() {
      clearTimeout(this.pendingTimeout);
      this.pendingTarget = null;
    }

    targetTop(target) {
      return target.element.getBoundingClientRect().top + window.scrollY;
    }

    /* The last section whose top has passed the bar. Going back to an earlier section needs the
       current one to be pushed a good way down again, so scrolling up slightly does not flip it. */
    findActiveTarget() {
      const viewportLine = window.scrollY + this.edgeOffset + ProductStickyNav.activeTolerance;
      let candidate = null;

      for (const target of this.targets) {
        if (this.targetTop(target) <= viewportLine) {
          candidate = target;
        }
      }

      if (!candidate || !this.activeTarget || candidate === this.activeTarget) {
        return candidate;
      }

      const isEarlier = this.targets.indexOf(candidate) < this.targets.indexOf(this.activeTarget);

      if (isEarlier && this.targetTop(this.activeTarget) <= viewportLine + ProductStickyNav.activeLeeway) {
        return this.activeTarget;
      }

      return candidate;
    }

    updateActiveTab() {
      const target = this.findActiveTarget();

      if (!target) {
        return;
      }

      this.activateTarget(target);
    }

    activateTarget(target) {
      const item = this.list.querySelector('[data-tab-id="' + target.name + '"]');

      if (!item) {
        return;
      }

      this.activeTarget = target;

      if (item.hasAttribute('data-active')) {
        return;
      }

      const previous = this.list.querySelector('[data-active]');

      if (previous) {
        previous.removeAttribute('data-active');
      }

      item.setAttribute('data-active', '');
      this.scrollTabToEdge(item);
    }

    /* Brings the tab flush with the edge of the list instead of leaving a gap */
    scrollTabToEdge(item) {
      const listRect = this.list.getBoundingClientRect();
      const itemRect = item.getBoundingClientRect();

      if (itemRect.left < listRect.left) {
        this.list.scrollTo({
          left: this.list.scrollLeft + (itemRect.left - listRect.left),
          behavior: 'smooth',
        });
        return;
      }

      if (itemRect.right > listRect.right) {
        this.list.scrollTo({
          left: this.list.scrollLeft + (itemRect.right - listRect.right),
          behavior: 'smooth',
        });
      }
    }

    onWindowScroll() {
      if (this.pendingTarget) {
        return;
      }

      const now = Date.now();

      if (now - this.lastScrollHandled < ProductStickyNav.scrollThrottleDelay) {
        return;
      }

      this.lastScrollHandled = now;
      this.updateActiveTab();
    }
  }

  if (!customElements.get('product-sticky-nav')) {
    customElements.define('product-sticky-nav', ProductStickyNav);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variations"] && !Shopify.designMode) return;
  try {
    class ProductVariations extends HTMLElement {
    connectedCallback() {
      this.load();
    }

    get wrapper() {
      return this.closest('.product-variations');
    }

    async load() {
      let content = null;

      try {
        content = this.parseSlideshow(await this.fetchVariations());
      } catch (error) {
        console.error(error);
      }

      if (content) {
        this.replaceChildren(content);
      } else if (!Shopify.designMode) {
        this.close();
        return;
      }

      const slideshow = this.querySelector('slideshow-component');

      if (!slideshow) {
        this.close();
        return;
      }

      const count = slideshow.querySelectorAll('slideshow-slides > *').length;
      this.updateCount(count);

      if (count < 4) {
        this.wrapper.classList.add('product-variations--center');
      }

      this.removeAttribute('data-loading');
    }

    async fetchVariations() {
      const query = encodeURIComponent(this.dataset.query);
      const response = await fetch(
        `${Shopify.routes.root}search?type=product&q=${query}&section_id=product-variations-helper`
      );

      if (!response.ok) {
        return null;
      }

      return await response.text();
    }

    parseSlideshow(markup) {
      if (!markup) {
        return null;
      }

      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const slideshow = parsed.querySelector('slideshow-component');

      if (!slideshow) {
        return null;
      }

      const content = document.createDocumentFragment();
      content.append(document.importNode(slideshow, true));

      return content;
    }

    updateCount(count) {
      this.wrapper.querySelectorAll('[data-variations-count]').forEach(function (element) {
        element.textContent = count;
      });
    }

    close() {
      this.wrapper.hidden = true;
      this.removeAttribute('data-loading');
    }
  }

  if (!customElements.get('product-variations')) {
    customElements.define('product-variations', ProductVariations);
  }
  } catch(e) { console.error(e); }
})();

})();
